// src/data/products.js

export const freeProducts = [
  {
    id: "FREE-1",
    name: "Alkeme Portfolio Tracker",
    blurb: "Track your assets in real-time with a clean UI.",
    price: 0,
    rating: 4.8,
    features: ["Crypto tracking", "Stock tracking", "Clean charts"],
    tier: "Free",
    url: "https://alkemeux.com",
  },
  {
    id: "FREE-2",
    name: "Alkeme Notes",
    blurb: "Simple, clean, minimal note-taking tool.",
    price: 0,
    rating: 4.6,
    features: ["Instant sync", "Cloud storage", "Zero ads"],
    tier: "Free",
  },
];

export const premiumProducts = [
  {
    id: "PREM-1",
    name: "Alkeme AI Markets",
    blurb: "Live AI-driven insights for crypto, stocks & prediction markets.",
    price: 14,
    rating: 4.9,
    features: [
      "Realtime AI signals",
      "Market-level insights",
      "Portfolio optimization",
    ],
    tier: "Premium",
    url: "https://alkemeux.com",
  },
  {
    id: "PREM-2",
    name: "Alkeme Quant Suite",
    blurb: "Build and backtest quant strategies with no code.",
    price: 29,
    rating: 4.95,
    features: ["Backtesting", "Live signals", "Strategy builder"],
    tier: "Premium",
  },
];
